'use client';

import { createContext, useContext } from 'react';

type TopProviderNavigationTarget = { provider_id: string | number };
type TopProviderNavigationHandler = (
  provider: TopProviderNavigationTarget
) => void;

const TopProviderNavigationContext =
  createContext<TopProviderNavigationHandler | null>(null);

export const useTopProviderNavigation = () =>
  useContext(TopProviderNavigationContext);

interface TopProviderNavigationProviderProps {
  onNavigate: TopProviderNavigationHandler;
  children: React.ReactNode;
}

export const TopProviderNavigationProvider: React.FC<
  TopProviderNavigationProviderProps
> = ({ onNavigate, children }) => (
  <TopProviderNavigationContext.Provider value={onNavigate}>
    {children}
  </TopProviderNavigationContext.Provider>
);
